import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import axios from 'axios';
import { toast } from 'react-toastify';
import { removeLoadingKey } from '../helpers/common';

export const TripleWhaleSettingsLoadingKeys = {
  fetch: 'FETCH_TRIPLE_WHALE_SETTINGS',
  save: 'SAVE_TRIPLE_WHALE_SETTINGS',
};

const initialState = {
  tripleWhaleSettings: {
    beroas: '',
  },
  loading: false,
  loadingKeys: [],
  error: null,
};

export const fetchTripleWhaleSettings = createAsyncThunk(
  'tripleWhaleSettingsSlice/fetchTripleWhaleSettings',
  async (_, { rejectWithValue }) => {
    try {
      const res = await axios.get('/api/v1/metadata/triple-whale-settings');
      return res.data;
    } catch (error) {
      const message =
        error.response?.data?.error || 'Failed to load Beroas settings';
      return rejectWithValue(message);
    }
  }
);

export const saveTripleWhaleSettings = createAsyncThunk(
  'tripleWhaleSettingsSlice/saveTripleWhaleSettings',
  async ({ beroas }, { rejectWithValue }) => {
    try {
      const res = await axios.post('/api/v1/metadata/triple-whale-settings', {
        beroas,
      });
      toast.success('Beroas saved successfully', { position: 'bottom-right' });
      return res.data;
    } catch (error) {
      const message =
        error.response?.data?.error || 'Failed to update Beroas settings';
      toast.error(message, { position: 'bottom-right' });
      return rejectWithValue(message);
    }
  }
);

const tripleWhaleSettingsSlice = createSlice({
  name: 'tripleWhaleSettingsSlice',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchTripleWhaleSettings.pending, (state) => {
        state.loading = true;
        state.error = null;
        state.loadingKeys = [...state.loadingKeys, TripleWhaleSettingsLoadingKeys.fetch];
      })
      .addCase(fetchTripleWhaleSettings.fulfilled, (state, action) => {
        state.tripleWhaleSettings = action.payload?.settings || { beroas: '' };
        state.loadingKeys = removeLoadingKey(TripleWhaleSettingsLoadingKeys.fetch, state.loadingKeys);
        state.loading = state.loadingKeys.length > 0;
      })
      .addCase(fetchTripleWhaleSettings.rejected, (state, action) => {
        state.error = action.payload || 'Failed to load Beroas settings';
        state.tripleWhaleSettings = {
          beroas: '',
        };
        state.loadingKeys = removeLoadingKey(TripleWhaleSettingsLoadingKeys.fetch, state.loadingKeys);
        state.loading = state.loadingKeys.length > 0;
      })
      .addCase(saveTripleWhaleSettings.pending, (state) => {
        state.error = null;
        state.loading = true;
        state.loadingKeys = [...state.loadingKeys, TripleWhaleSettingsLoadingKeys.save];
      })
      .addCase(saveTripleWhaleSettings.fulfilled, (state, action) => {
        state.beroas = action.payload || '';
        state.loadingKeys = removeLoadingKey(TripleWhaleSettingsLoadingKeys.save, state.loadingKeys);
        state.loading = state.loadingKeys.length > 0;
      })
      .addCase(saveTripleWhaleSettings.rejected, (state, action) => {
        state.error = action.payload || 'Failed to update Beroas settings';
        state.loadingKeys = removeLoadingKey(TripleWhaleSettingsLoadingKeys.save, state.loadingKeys);
        state.loading = state.loadingKeys.length > 0;
      });
  },
});

export const { } = tripleWhaleSettingsSlice.actions;

export default tripleWhaleSettingsSlice.reducer;


